module.exports = __webpack_public_path__ + "img/logod.c64861ed.png";